import { i18next } from '@yola/ws-sdk';
import { DESIGN_MENU_ID } from 'yola-editor/src/js/modules/editor/constants';

import optionIds from '../constants/option-ids';

const getDesignMenuItems = (designMenuItemClickCallbacks) => {
  const {
    colorsOnClick,
    fontsOnClick,
    buttonsOnClick,
    effectsOnClick,
    otherStylesOnClick,
    switchTemplateOnClick,
  } = designMenuItemClickCallbacks;

  return {
    id: DESIGN_MENU_ID,
    heading: i18next.t('Design'),
    order: 90,
    target: '_blank',
    iconGlyph: 'design',
    submenu: [
      {
        title: i18next.t('Colors'),
        heading: i18next.t('Colors'),
        id: optionIds.COLORS,
        description: '',
        iconGlyph: 'design-colors',
        order: 1,
        onClick: colorsOnClick,
      },
      {
        title: i18next.t('Fonts'),
        heading: i18next.t('Fonts'),
        id: optionIds.FONTS,
        description: '',
        iconGlyph: 'design-fonts',
        order: 2,
        onClick: fontsOnClick,
      },
      {
        title: i18next.t('Buttons'),
        heading: i18next.t('Buttons'),
        id: optionIds.BUTTONS,
        description: '',
        iconGlyph: 'button',
        order: 3,
        onClick: buttonsOnClick,
      },
      {
        title: i18next.t('Effects'),
        heading: i18next.t('Effects'),
        id: optionIds.EFFECTS,
        description: '',
        iconGlyph: 'design-effects',
        order: 4,
        onClick: effectsOnClick,
      },
      {
        title: i18next.t('Other styles'),
        heading: i18next.t('Other styles'),
        id: optionIds.OTHER_STYLES,
        description: '',
        iconGlyph: 'other-styles',
        order: 5,
        onClick: otherStylesOnClick,
      },
      {
        title: i18next.t('Switch template'),
        heading: i18next.t('Switch template'),
        id: optionIds.TEMPLATE_SWITCHING,
        description: '',
        iconGlyph: 'design-switch',
        order: 6,
        onClick: switchTemplateOnClick,
      },
    ],
  };
};

export default getDesignMenuItems;
